// src/components/AddedToBagToast.js
import React from "react";
import { useCart } from "../context/CartContext";

function AddedToBagToast() {
  const { addedToast, lang } = useCart();

  if (!addedToast) return null;

  const message =
    lang === "EN"
      ? `🎉 "${addedToast.nameEN}" added to your cart!`
      : `🎉 تمت إضافة "${addedToast.nameAR}" إلى السلة`;

  return (
    <div
      className="
        fixed
        top-[100px]
        left-1/2
        -translate-x-1/2
        z-[99999]

        px-6 py-4
        rounded-2xl
        text-[14px] md:text-sm
        font-extrabold
        text-white

        shadow-[0_15px_40px_rgba(0,0,0,0.25)]
        backdrop-blur-sm

        flex items-center gap-3

        animate-bounceIn
      "
      style={{
        background:
          "linear-gradient(90deg,#F97316,#EF4444,#EC4899,#8B5CF6,#2563EB)",
        backgroundSize: "200% 200%",
        animation: "gradientShift 6s ease infinite",
      }}
    >
      {/* BIG CHECK ICON */}
      <span className="text-xl">🧸</span>

      <span>{message}</span>

      {/* FUN SPARKLE */}
      <span className="text-lg animate-pulse">✨</span>

      {/* LOCAL ANIMATION */}
      <style>{`
        @keyframes bounceIn {
          0% { transform: translate(-50%, -20px) scale(0.9); opacity: 0; }
          50% { transform: translate(-50%, 5px) scale(1.05); opacity: 1; }
          100% { transform: translate(-50%, 0) scale(1); opacity: 1; }
        }

        .animate-bounceIn {
          animation: bounceIn 0.5s ease forwards;
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}

export default AddedToBagToast;